import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

function createPasswordFailure(draft: Draft<IAuthData>) {
  draft.createPassword.config.isLoading = false;
}

export default createPasswordFailure;
